export default __webpack_public_path__ + "static/media/image1.42297c7d.png";